import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTokenValid } from 'hooks/auth/Token';
import { useAuth } from './AuthContext';
import { useDI } from './DIContext';
import { refreshAccessToken } from "../hooks/fetch/Fetch";

export const Login = () => {
    const { useJwtTokenHook, config } = useDI();
    const [accessToken] = useJwtTokenHook();

    const { token, setToken } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const stateReturnPath =
        typeof location.state?.from === 'string'
            ? location.state.from
            : undefined;

    useEffect(() => {
        const shouldUpdateToken = isTokenValid(accessToken, false) && (!isTokenValid(token, false) || accessToken.accessToken !== token.accessToken);

        if (shouldUpdateToken) {
            setToken(accessToken);
            return;
        }

        if (isTokenValid(token, false)) {
            const destination = sessionStorage.getItem('authReturnPath') ?? stateReturnPath ?? '/article-search';

            sessionStorage.removeItem('authReturnPath');
            navigate(destination, { replace: true });
            return;
        }

        if (token === null) {
            return;
        }

        let active = true;

        void refreshAccessToken(token, config.refreshTokenUrl, fetch)
            .then(refreshedToken => {
                if (active) {
                    setToken(refreshedToken);
                }
            })
            .catch(() => {
                if (active) {
                    setToken(null);
                }
            });

        return () => {
            active = false;
        };
    }, [accessToken, token, setToken, config.refreshTokenUrl, stateReturnPath, navigate]);
    
    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 z-50 flex justify-center items-center text-white backdrop-blur-sm">
            <div className="flex flex-col justify-center items-center">
                {/* CSS Spinner */}
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Checking authorization
            </div>
        </div>
    );
};